const HIGHLIGHT_DOMAIN = 'highlights'

const HIGHLIGHT_KEY = {
  ALL: 'all',
  DATA: 'data'
}

const HIGHLIGHT_PATH = {
  DATA: `${HIGHLIGHT_DOMAIN}.${HIGHLIGHT_KEY.DATA}`,
  ALL: `${HIGHLIGHT_DOMAIN}.${HIGHLIGHT_KEY.ALL}`,
  ALL_DATA: `${HIGHLIGHT_DOMAIN}.${HIGHLIGHT_KEY.ALL}.data`
}

const HIGHLIGHT_STATE = {
  [HIGHLIGHT_KEY.ALL]: {
    data: [],
    status: null
  },
  [HIGHLIGHT_KEY.DATA]: {}
}

const HIGHLIGHT_ACTION = {
  LOAD: 'HIGHLIGHT_LOAD'
}

const HIGHLIGHT_ANALYTICS_EVENT = {
  LOADED: 'Highlights Loaded'
}

const HIGHLIGHT_ENDPOINT = {
  HIGHLIGHT: '/highlights'
}

export {
  HIGHLIGHT_DOMAIN,
  HIGHLIGHT_KEY,
  HIGHLIGHT_PATH,
  HIGHLIGHT_STATE,
  HIGHLIGHT_ACTION,
  HIGHLIGHT_ANALYTICS_EVENT,
  HIGHLIGHT_ENDPOINT
}
